import { NavigationItemsProvider } from "./app/NavigationItemsContext";
import { ApplicationProvider } from "./app/ApplicationsContext";
import { ApplicationManagerContextProvider } from "./app/ApplicationManagerContext";
import SnackbarContextProvider from "./app/SnackbarContext";
import { SysadminContextProvider } from "./app/SysadminContext";
import { SeatApplicationManagerContextProvider } from "./app/SeatApplicationManagerContext";
import { AppContextProvider } from "./app/AppContext";
import { AIAssistantContextProvider } from "./app/AIAssistantContext";
import { AIAssistantChatContextProvider } from "./app/AIAssistantChatContext";
import { SysadminAIAssistantTemplateContextProvider } from "./app/SysadminAIAssistantTemplateContext";

const AppContexts = ({ children }) => {
  return (
    <AppContextProvider>
      <NavigationItemsProvider>
        <SysadminContextProvider>
          <SysadminAIAssistantTemplateContextProvider>
            <ApplicationProvider>
              <ApplicationManagerContextProvider>
                <SeatApplicationManagerContextProvider>
                  <AIAssistantContextProvider>
                    <AIAssistantChatContextProvider>
                      <SnackbarContextProvider>
                        {children}
                      </SnackbarContextProvider>
                    </AIAssistantChatContextProvider>
                  </AIAssistantContextProvider>
                </SeatApplicationManagerContextProvider>
              </ApplicationManagerContextProvider>
            </ApplicationProvider>
          </SysadminAIAssistantTemplateContextProvider>
        </SysadminContextProvider>
      </NavigationItemsProvider>
    </AppContextProvider>
  );
};

export default AppContexts;
